const LOGO_SRC =
  "https://customer-assets.emergentagent.com/job_7e3844cb-5760-4775-a529-477db24cc90c/artifacts/mt28f7h3_248319.jpg";

export default function Logo({ size = 48, className = "" }) {
  return (
    <img
      src={LOGO_SRC}
      alt="Cheeky Monkeys Playgroup logo"
      width={size * 2}
      height={size}
      style={{ height: size, width: "auto" }}
      className={`block object-contain select-none ${className}`}
      draggable={false}
    />
  );
}
